import { SET_TABLE_ONE_EVENT_TPA_REPORT,SET_TABLE_TWO_STOCK_TPA_REPORT,SET_TABLE_THREE_SHRINKAGE_TPA_REPORT,SET_TABLE_FOUR_ONSHORE_TPA_REPORT} from './actionType'



export const setTableOneEventTPAToState = (payload) => ({
  type: SET_TABLE_ONE_EVENT_TPA_REPORT,
  payload
})
export const setTableTwoStockTPAToState = (payload) => ({
  type: SET_TABLE_TWO_STOCK_TPA_REPORT,
  payload
})
export const setTableThreeShrinkageTPAToState = (payload) => ({
  type: SET_TABLE_THREE_SHRINKAGE_TPA_REPORT,
  payload
})
export const setTableFourOnshoreToState = (payload) => ({
  type: SET_TABLE_FOUR_ONSHORE_TPA_REPORT,
  payload
})

